import { render } from "./login-screen.vue?vue&type=template&id=06bcb402&scoped=true"
import script from "./login-screen.vue?vue&type=script&lang=js"
export * from "./login-screen.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-06bcb402"

export default script